import { render, staticRenderFns } from "./UnboxItemElement.vue?vue&type=template&id=f234fb6c&scoped=true"
import script from "./UnboxItemElement.vue?vue&type=script&lang=js"
export * from "./UnboxItemElement.vue?vue&type=script&lang=js"
import style0 from "./UnboxItemElement.vue?vue&type=style&index=0&id=f234fb6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f234fb6c",
  null
  
)

export default component.exports